import Lightbox from "bs5-lightbox";
export function bs5Lightbox() {
  // are we on the Property Detail page?
  if (document.querySelector(".airbnb")) {
    // yes

    const options = {
      keyboard: true,
      size: "fullscreen",
      gallery: "property-lightbox",
      interval: false,
      ride: false,
    };

    document.querySelectorAll(".launch-gallery").forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        const lightbox = new Lightbox(el, options);
        lightbox.show();
      })
    );
  }
}
